import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { testUrl } from "../BaseData";
import classes from "./GrantlarVaLoyihalar.module.css";
import GrantCard from "./GrantCard";
import { getLabels, sortGrants } from "./grantUtils";

// Filtr variantlari: [qiymat, yorliq kaliti]
const AUDIENCE_OPTIONS = [
  ["students", "students"],
  ["teachers", "teachers"],
];
const SCOPE_OPTIONS = [
  ["international", "international"],
  ["local", "local"],
];
const AUDIENCE_VALUES = AUDIENCE_OPTIONS.map(([v]) => v);
const SCOPE_VALUES = SCOPE_OPTIONS.map(([v]) => v);

const GrantlarVaLoyihalar = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const L = getLabels(lang);

  const [searchParams, setSearchParams] = useSearchParams();
  // Standart: Talabalarga + Xalqaro
  const audienceParam = searchParams.get("kimga");
  const scopeParam = searchParams.get("turi");
  const audience = AUDIENCE_VALUES.includes(audienceParam) ? audienceParam : "students"; // students | teachers
  const scope = SCOPE_VALUES.includes(scopeParam) ? scopeParam : "international"; // international | local

  const [grants, setGrants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    axios
      .get(`${testUrl}/api/grants/`)
      .then((res) => setGrants(Array.isArray(res.data) ? res.data : []))
      .catch(() => setError(L.error))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), 2000);
    return () => clearTimeout(t);
  }, [toast]);

  const setFilter = (key, value) => {
    const next = new URLSearchParams(searchParams);
    next.set(key, value);
    setSearchParams(next, { replace: true });
  };

  // Filtrlash brauzerda — tugma bosilganda darhol yangilanadi
  const visible = useMemo(() => {
    const filtered = grants.filter((g) => {
      // "all" auditoriyali grantlar ikkala filtrda ham chiqadi
      const okAudience = g.audience === audience || g.audience === "all";
      const okScope = g.scope === scope;
      return okAudience && okScope;
    });
    return sortGrants(filtered);
  }, [grants, audience, scope]);

  return (
    <div className={classes.page}>
      <h1 className={classes.pageTitle}>{L.pageTitle}</h1>

      <div className={classes.filters}>
        {/* 1-qator: Talabalarga / O'qituvchilarga */}
        <div className={classes.filterRow}>
          {AUDIENCE_OPTIONS.map(([value, key]) => (
            <button
              key={value}
              type="button"
              className={`${classes.filterBtn} ${
                audience === value ? classes.filterBtnActive : ""
              }`}
              onClick={() => setFilter("kimga", value)}
            >
              {L[key]}
            </button>
          ))}
        </div>

        {/* 2-qator: Xalqaro / Mahalliy */}
        <div className={`${classes.filterRow} ${classes.filterRowSecondary}`}>
          {SCOPE_OPTIONS.map(([value, key]) => (
            <button
              key={value}
              type="button"
              className={`${classes.filterBtn} ${
                scope === value ? classes.filterBtnActive : ""
              }`}
              onClick={() => setFilter("turi", value)}
            >
              {L[key]}
            </button>
          ))}
        </div>
      </div>

      {loading && <div className={classes.status}>{L.loading}</div>}
      {!loading && error && <div className={classes.status}>{error}</div>}
      {!loading && !error && visible.length === 0 && (
        <div className={classes.status}>{L.empty}</div>
      )}

      {!loading && !error && visible.length > 0 && (
        <div className={classes.grid} data-aos="fade-up">
          {visible.map((item) => (
            <GrantCard key={item.id} item={item} lang={lang} onToast={setToast} />
          ))}
        </div>
      )}

      {toast && <div className={classes.toast}>{toast}</div>}
    </div>
  );
};

export default GrantlarVaLoyihalar;
